import {createSlice} from '@reduxjs/toolkit';

import {CONFIGS_FIELDS} from '../constants';
import type {Config, OrderItem} from '../types';

import {fetchConfig, fetchOrders} from '../actions';

import {RootState} from '../store';

const name = 'global';

export const initialState = {
  config: {data: null, loading: false},
  orders: {data: [], loading: false, count: 0},
};

const globalSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchConfig.pending, state => {
        state.config.loading = true;
      })
      .addCase(fetchConfig.fulfilled, (state, {payload: {payload}}) => {
        state.config.loading = false;
        state.config.data = payload;
      })
      .addCase(fetchConfig.rejected, state => {
        state.config.loading = false;
      })
      .addCase(fetchOrders.pending, state => {
        state.orders.loading = true;
      })
      .addCase(fetchOrders.fulfilled, (state, {payload: {count, results}}) => {
        state.orders.loading = false;
        state.orders.data = results;
        state.orders.count = count;
      })
      .addCase(fetchOrders.rejected, state => {
        state.orders.loading = false;
      });
  },
});

export default globalSlice;

export const selectConfig = (state: RootState): Config =>
  state[name].config.data;

export const selectConfigField =
  <K extends keyof Config>(name: K) =>
  (state: RootState): Config[K] =>
    selectConfig(state)?.[name];

export const selectSomethingWrong = (state: RootState): boolean =>
  !selectConfig(state);

export const selectConfigLoading = (state: RootState): boolean =>
  state[name].config.loading;

export const selectDefaultFields =
  (name: string) =>
  (state: RootState): string[] =>
    selectConfig(state)?.[CONFIGS_FIELDS.PROFILE_DEFAULTS][name];

export const selectCarrierLogo =
  (name: string) =>
  (state: RootState): string =>
    selectConfig(state)?.[CONFIGS_FIELDS.CARRIER_LOGOS]?.[name];

export const selectOrders = (state: RootState): OrderItem[] =>
  state[name].orders.data;

export const selectOrdersCount = (state: RootState): number =>
  state[name].orders.count;

export const selectOrdersLoading = (state: RootState): boolean =>
  state[name].orders.loading;
